import React from "react";
import { ExistingEntityPreviewProps } from "../ExistingEntityPreview";

const ExistingInteractionPreview = (props: ExistingEntityPreviewProps) => {
  return (
    <iframe
      title="Interaction Preview"
      src={process.env.REACT_APP_URL + "/contents/s" + props.id + "+"}
      height={600}
      width={"100%"}
    ></iframe>
  );
};

export default ExistingInteractionPreview;
